import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IonAccordionGroup, IonModal } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { CustomModal, DefaultObject } from '@shared/interfaces/index';

@Component({
	selector: 'manifest-documents',
	template: `
		<div class="ion-padding" slot="content" *ngIf="!passenger.documentsSigned">
			<div class="grid grid-cols-1 gap-2">
				<ion-button
					(click)="loadForms('waiver', passenger)"
					*ngIf="requiredDocuments[passenger.type].includes('waiver')"
					color="tertiary"
					expand="block"
				>
					<ion-icon
						*ngIf="passenger.documents.waiver"
						class=" left-1"
						name="checkmark-circle"
					></ion-icon>
					<span *ngIf="!passenger.documents.waiver">Review&nbsp;</span> Waiver
				</ion-button>
				<ion-button
					(click)="loadForms('rentalAgreement', passenger)"
					*ngIf="requiredDocuments[passenger.type].includes('rentalAgreement')"
					color="tertiary"
					expand="block"
				>
					<ion-icon
						*ngIf="passenger.documents.rentalAgreement"
						class=" left-1"
						name="checkmark-circle"
					></ion-icon>
					<span *ngIf="!passenger.documents.rentalAgreement">Review&nbsp;</span>
					Rental Agreement
				</ion-button>
				<ion-button
					(click)="loadForms('navRules', passenger)"
					*ngIf="requiredDocuments[passenger.type].includes('navRules')"
					color="tertiary"
					expand="block"
				>
					<ion-icon
						*ngIf="passenger.documents.navRules"
						class=" left-1"
						name="checkmark-circle"
					></ion-icon>
					<span *ngIf="!passenger.documents.navRules">Review&nbsp;</span> Nav Rules
				</ion-button>
				<ion-button
					(click)="loadForms('acknowledgement', passenger)"
					*ngIf="requiredDocuments[passenger.type].includes('acknowledgement')"
					color="tertiary"
					expand="block"
				>
					<ion-icon
						*ngIf="passenger.documents.acknowledgement"
						class=" left-1"
						name="checkmark-circle"
					></ion-icon>
					<span *ngIf="!passenger.documents.acknowledgement">Review&nbsp;</span>
					Acknowledgements
				</ion-button>

				<ion-button
					(click)="passengerSignature(passenger)"
					[passengerCanSign]="passenger"
					[requiredDocuments]="requiredDocuments"
					expand="block"
					class="w-full"
				>
					Sign Documents
				</ion-button>

				<div class="flex flex-col py-2 border-t-2">
					<ion-button
						(click)="openEditPassengerForm(passenger)"
						expand="block"
						class="w-2/3 h-10 mx-auto"
						color="secondary"
						size="small"
					>
						Edit
					</ion-button>
					<ion-button
						*ngIf="index > 0"
						(click)="removePassenger(passenger)"
						size="small"
						expand="block"
						class="w-2/3 h-10 italic mx-auto"
						color="danger"
					>
						Remove
					</ion-button>
				</div>
			</div>
		</div>
		<div *ngIf="passenger.documentsSigned">
			<div class="bg-green-50 rounded p-4 text-center text-sm text-gray-800 relative">
				<div>All documents signed</div>
			</div>
			<ion-button
				*ngIf="index > 0 && launchType == 'checkin'"
				(click)="removePassenger(passenger)"
				size="small"
				expand="block"
				class="w-full"
				color="danger"
			>
				Remove
			</ion-button>
		</div>
		<signature-modal
			[fullscreen]="true"
			(onModalClose)="passengerSignatureSave($event)"
			#signatureModal
		></signature-modal>
		<ion-modal #documentModal (willDismiss)="onWillDismiss($event)">
			<ng-template>
				<ion-header>
					<ion-toolbar>
						<ion-title>I Agree &amp; Understand</ion-title>
					</ion-toolbar>
				</ion-header>
				<ion-content class="ion-padding">
					<div [innerHtml]="doc" class="text-lg mt-2 p-2"></div>
					<ion-button
						data-cy="i-agree-button"
						expand="block"
						(click)="close()"
						[strong]="true"
						>I Agree &amp; Understand the {{ formName }}
					</ion-button>
				</ion-content>
			</ng-template>
		</ion-modal>
	`,
})
export class ManifestDocumentsComponent implements OnInit {
	@ViewChild('accordionGroup', { static: true }) accordionGroup: IonAccordionGroup;
	@Input() passenger: DefaultObject = {};
	@Input() requiredDocuments: DefaultObject = {};
	@Input() documents: DefaultObject = {};
	@Input() index: string = '';
	@Input() launchType: string = 'pre';

	@Output() onPassengerChange: EventEmitter<any> = new EventEmitter();
	@Output() onPassengerUpdate: EventEmitter<any> = new EventEmitter();
	@Output() onPassengerSave: EventEmitter<any> = new EventEmitter();
	@ViewChild('documentModal') documentModal: IonModal;
	@ViewChild('signatureModal') signatureModal: CustomModal;

	public formName: string;
	get documentFormName() {
		return this.formName;
	}
	set documentFormName(name) {
		this.formName = name;
	}
	public doc: SafeHtml;
	get document() {
		return this.doc;
	}
	set document(doc) {
		this.doc = doc;
	}
	public formKey: string;
	get key() {
		return this.formKey;
	}
	set key(key) {
		this.formKey = key;
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private sanitizer: DomSanitizer) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - ngOnInit
	 **-------------------------------------------------------------------------------------
	 */
	ngOnInit() {
		console.log(this.passenger, this.requiredDocuments);
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - loadForms
	 **-------------------------------------------------------------------------------------
	 */
	public async loadForms(form, index) {
		const document = this.documents[form];
		this.documentFormName = document.name;
		this.document = this.prepareDocument(document.doc);
		this.key = form;
		this.documentModal.present();
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - passengerSignature
	 **-------------------------------------------------------------------------------------
	 */
	public passengerSignature(item) {
		this.signatureModal.create(item).present();
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - passengerSignature
	 **-------------------------------------------------------------------------------------
	 */
	public passengerSignatureSave(passenger) {
		this.onPassengerSave.emit({
			passenger,
			type: 'update',
		});
		this.documentModal.dismiss(null, 'close');
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - cancel
	 **-------------------------------------------------------------------------------------
	 */
	public close() {
		this.documentModal.dismiss(null, 'confirm');
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - removePassenger
	 **-------------------------------------------------------------------------------------
	 */
	public removePassenger(passenger) {
		this.onPassengerSave.emit({
			passenger,
			type: 'remove',
		});
		this.documentModal.dismiss(null, 'confirm');
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - openEditPassengerForm
	 **-------------------------------------------------------------------------------------
	 */
	public openEditPassengerForm(passenger) {
		this.onPassengerUpdate.emit(passenger);
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - onWillDismiess
	 **-------------------------------------------------------------------------------------
	 */
	onWillDismiss(event: Event) {
		const ev = event as CustomEvent<OverlayEventDetail<string>>;
		if (ev.detail.role === 'confirm') {
			this.onPassengerChange.emit({
				formName: this.formName,
				index: this.index,
				passenger: {
					...this.passenger,
					documents: {
						...this.passenger.documents,
						[this.key]: true,
					},
				},
			});
		}
	}

	prepareDocument(document) {
		return this.sanitizer.bypassSecurityTrustHtml(this.replaceSignaturePlaceholders(document));
	}

	replaceSignaturePlaceholders(doc) {
		const signatureToken = "$signature$";
		const initialsToken = "$initials$";
		const signatureRegex = new RegExp(signatureToken.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&'), "g");
		const initialsRegex = new RegExp(initialsToken.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&'), "g");

		return doc
			.replace(signatureRegex, '____________________')
			.replace(initialsRegex, '____________________');
	}
}
